<template>
    <v-overlay v-if="overlay.show">
        <v-img
            :src="overlay.src"
            contain
            max-width="80vw"
            max-height="80vh"
            style="cursor: pointer"
            @click="hideOverlay"
            v-click-outside="hideOverlay"
        />
    </v-overlay>
</template>
<script>
export default {
    props: {
        overlay: {
            show: Boolean,
            src: String,
        },
    },
    methods: {
        hideOverlay() {
            if (this.overlay.show) this.$emit("hide-overlay");
        },
    },
};
</script>